export interface Debouncer<T> {
  run(value: T): void;
  cancel(): void;
}

export function debounce<T>(
  delayMs: number,
  fn: (value: T) => void
): Debouncer<T> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return {
    run(value: T) {
      if (timeoutId != null) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        timeoutId = null;
        fn(value);
      }, delayMs);
    },
    cancel() {
      if (timeoutId != null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }
  };
}
